import { Box, Skeleton, ToggleButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import {
  setCategoryExplor,
  setSearchExplore,
} from "../../../../redux/features/settingSlice";

const AboutTags = ({ about }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSearchTag = (tagName) => {
    dispatch(setSearchExplore(tagName));
    navigate("/explore");
    dispatch(setCategoryExplor(null));
  };

  return (
    <Box sx={{ marginBottom: "18px" }}>
      {!about &&
        Array(3)
          .fill("")
          .map((e, i) => {
            return (
              <Box
                key={i}
                sx={{
                  fontSize: "12px",
                  display: "inline-flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  color: "#7c7c7c",
                  pl: "0px !IMPORTANT",
                  marginBottom: "8px",
                  height: "30px",
                  pr: "8px",
                }}
              >
                <Skeleton width={50} height={35} />
              </Box>
            );
          })}
      {about?.tags.map((row, i) => {
        return (
          <Box
            onClick={() => handleSearchTag(row)}
            key={i}
            sx={{
              border: "2px solid #7c7c7c",
              display: "inline-flex",
              borderRadius: "6px",
              color: "#7c7c7c",
              marginRight: "8px",
              marginBottom: "8px",
              height: "28px",
            }}
          >
            <ToggleButton
              sx={{
                padding: "6px 8px 3px 8px",
                textTransform: "none",
                fontSize: "12px",
                lineHeight: "20px",
                border: "none",
                "&.MuiButtonBase-root:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0)",
                },
              }}
              value='check'
            >
              {row}
            </ToggleButton>
          </Box>
        );
      })}
    </Box>
  );
};
export default AboutTags;
